import React from "react";
import { Badge } from "reactstrap";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { FINANCIAL_TYPES } from "../../../../constants/financial";

/**
 * FinancialCategorySidebar
 * Lista de categorias financeiras usando o MasterSidebar padronizado.
 */
const FinancialCategorySidebar = ({ categories, activeId, onSelect, onCreateNew, loading }) => {

    // Renderização customizada de cada item
    const renderCategoryItem = (category, isActive) => (
        <div className="text-start overflow-hidden w-100">
            <div className="d-flex align-items-center justify-content-between mb-1">
                <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                    {category.name}
                </p>
            </div>
            <div className="d-flex align-items-center gap-2">
                <Badge
                    color={category.type === FINANCIAL_TYPES.INCOME ? 'success' : 'danger'}
                    className="font-size-10 px-2 opacity-75 rounded-0"
                >
                    {category.type === FINANCIAL_TYPES.INCOME ? 'Receita' : 'Despesa'}
                </Badge>
            </div>
        </div>
    );

    return (
        <MasterSidebar
            title="Categorias"
            subtitle="Plano de Contas (DRE)"
            items={categories}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar categoria..."
            icon="mdi mdi-tag-multiple-outline"
            renderItem={renderCategoryItem}
            loadingMessage="Carregando categorias..."
        />
    );
};

FinancialCategorySidebar.propTypes = {
    categories: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool
};

export default FinancialCategorySidebar;
